import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Bar } from "react-chartjs-2";
import { useCookies } from 'react-cookie';

function Stats(props) {
	let history = useHistory();
	const [cookies] = useCookies(['user']);
	const user_id = cookies.user_id;
	const token = cookies.token;
    const { state } = props.location
	const [stats, setStats] = useState(state[0]);
	const [distId] = useState(state[1]);
	const [css, setCss] = useState({});
	console.log(user_id === undefined);
	const [chartLable, setChartLable] = useState("");
	console.log(stats);
	useEffect(() => {
		let csss = {"dau_percentage" : "btn btn-outline-success success-btn px-0","dau_percentage_img": require("./../images/up.png").default,
		"tpr_percentage" : "btn btn-outline-success success-btn px-0","tpr_percentage_img": require("./../images/up.png").default,
		"ppr_percentage" : "btn btn-outline-success success-btn px-0","ppr_percentage_img": require("./../images/up.png").default,
		"ul_percentage" : "btn btn-outline-success success-btn px-0","ul_percentage_img": require("./../images/up.png").default};
		
		if(stats.dau_percentage > 0){
			csss.dau_percentage = "btn btn-outline-success success-btn px-0";
			csss.dau_percentage_img = require("./../images/up.png").default;
		} else if(stats.dau_percentage === 0){
			csss.dau_percentage = "btn btn-outline-success success-btn px-0";
			csss.dau_percentage_img = require("./../images/up.png").default;
		} else {
			csss.dau_percentage = "btn btn-outline-danger danger-btn px-0";
			csss.dau_percentage_img = require("./../images/down.png").default;
		}
		if(stats.tpr_percentage > 0){
			csss.tpr_percentage = "btn btn-outline-success success-btn px-0";
			csss.tpr_percentage_img = require("./../images/up.png").default;
		} else if(stats.tpr_percentage === 0){
			csss.tpr_percentage = "btn btn-outline-success success-btn px-0";
			csss.tpr_percentage_img = require("./../images/up.png").default;
		} else {
			csss.tpr_percentage = "btn btn-outline-danger danger-btn px-0";
			csss.tpr_percentage_img = require("./../images/down.png").default;
		}
		if(stats.ppr_percentage > 0){
			csss.ppr_percentage = "btn btn-outline-success success-btn px-0";
			csss.ppr_percentage_img = require("./../images/up.png").default;
		} else if(stats.ppr_percentage === 0){
			csss.ppr_percentage = "btn btn-outline-success success-btn px-0";
			csss.ppr_percentage_img = require("./../images/up.png").default;
		} else {
			csss.ppr_percentage = "btn btn-outline-danger danger-btn px-0";
			csss.ppr_percentage_img = require("./../images/down.png").default;
		}
		if(stats.ul_percentage > 0){
			csss.ul_percentage = "btn btn-outline-danger danger-btn px-0";
			csss.ul_percentage_img = require("./../images/down.png").default;
		} else if(stats.ul_percentage === 0){
			csss.ul_percentage = "btn btn-outline-success success-btn px-0";
			csss.ul_percentage_img = require("./../images/up.png").default;
		} else {
			csss.ul_percentage = "btn btn-outline-success success-btn px-0";
			csss.ul_percentage_img = require("./../images/up.png").default;
		}
		setCss(csss);
		if (distId === undefined){
			setBlockCss(stats);
			loadChart("dau");
		} else {
			getDistributorStats();
		}

	}, []);
	
	const getDistributorStats = async () => {
		const requestOptions = {
			method: 'POST',
			headers: { 'Content-Type': 'application/json','token':token, 'userId':user_id },
			body: JSON.stringify({user_id:distId}),
			
		};
		const response = await fetch(process.env.REACT_APP_BKB_URL_DOMAIN + 'get-distributor-stats', requestOptions);
		console.log(requestOptions);
		const data = await response.json();
		console.log(data.stats.dau_data);
		if(JSON.stringify(data.stats) === JSON.stringify({})){
			let s = {"dau_percentage":0,"ppr_percentage":0,"tpr_percentage":0,"ul_percentage":0};
			setBlockCss(s);
			setStats(s);
			loadChart("dau", s);
		} else {
			setBlockCss(data.stats);
			setStats(data.stats);
			loadChart("dau", data.stats);
		}
	}
 
	async function setBlockCss(stats) {
		let csss = {"dau_percentage" : "btn btn-outline-success success-btn px-0","dau_percentage_img": require("./../images/up.png").default,
		"tpr_percentage" : "btn btn-outline-success success-btn px-0","tpr_percentage_img": require("./../images/up.png").default,
		"ppr_percentage" : "btn btn-outline-success success-btn px-0","ppr_percentage_img": require("./../images/up.png").default,
		"ul_percentage" : "btn btn-outline-success success-btn px-0","ul_percentage_img": require("./../images/up.png").default};
		
		if(stats.dau_percentage > 0){
			csss.dau_percentage = "btn btn-outline-success success-btn px-0";
			csss.dau_percentage_img = require("./../images/up.png").default;
		} else if(stats.dau_percentage === 0){
			csss.dau_percentage = "btn btn-outline-success success-btn px-0";
			csss.dau_percentage_img = require("./../images/up.png").default;
		} else {
			csss.dau_percentage = "btn btn-outline-danger danger-btn px-0";
			csss.dau_percentage_img = require("./../images/down.png").default;
		}
		if(stats.tpr_percentage > 0){
			csss.tpr_percentage = "btn btn-outline-success success-btn px-0";
			csss.tpr_percentage_img = require("./../images/up.png").default;
		} else if(stats.tpr_percentage === 0){
			csss.tpr_percentage = "btn btn-outline-success success-btn px-0";
			csss.tpr_percentage_img = require("./../images/up.png").default;
		} else {
			csss.tpr_percentage = "btn btn-outline-danger danger-btn px-0";
			csss.tpr_percentage_img = require("./../images/down.png").default;
		}
		if(stats.ppr_percentage > 0){
			csss.ppr_percentage = "btn btn-outline-success success-btn px-0";
			csss.ppr_percentage_img = require("./../images/up.png").default;
		} else if(stats.ppr_percentage === 0){
			csss.ppr_percentage = "btn btn-outline-success success-btn px-0";
			csss.ppr_percentage_img = require("./../images/up.png").default;
		} else {
			csss.ppr_percentage = "btn btn-outline-danger danger-btn px-0";
			csss.ppr_percentage_img = require("./../images/down.png").default;
		}
		if(stats.ul_percentage > 0){
			csss.ul_percentage = "btn btn-outline-danger danger-btn px-0";
			csss.ul_percentage_img = require("./../images/down.png").default;
		} else if(stats.ul_percentage === 0){
			csss.ul_percentage = "btn btn-outline-success success-btn px-0";
			csss.ul_percentage_img = require("./../images/up.png").default;
		} else {
			csss.ul_percentage = "btn btn-outline-success success-btn px-0";
			csss.ul_percentage_img = require("./../images/up.png").default;
		}
		// const [css] = useState(csss);
		setCss(csss);
	}

	async function loadChart(params, statsParams=''){
		console.log(params);
		var chartValue = [];
		var chartIndex = [];
		var desc = "";
		var s = stats;
		if(statsParams != ''){
			s = statsParams;
		}

		if(params === "dau"){
			desc = "Daily Active Users";
			if(s.dau_data !== undefined)
			for (const [index, value] of s.dau_data.entries()) {
				chartValue[index] = value.dau;
				//let month = value.month;
				chartIndex[index] = value.month;
			}
		} else if(params === "ppr"){
			desc = "Product Per Retailer";
			if(s.ppr_data !== undefined)
			for (const [index, value] of s.ppr_data.entries()) {
				chartValue[index] = value.ppr;
				chartIndex[index] = value.month;
			}
		} else if(params === "tpr"){
			desc = "Average Token Per Retailer";
			if(s.tpr_data !== undefined)
			for (const [index, value] of s.tpr_data.entries()) {
				chartValue[index] = value.tpr;
				//let month = value.month;
				chartIndex[index] = value.month;
			}
		} else {
			desc = "Retailer Leaving Distributors";
			if(s.ul_data !== undefined)
			for (const [index, value] of s.ul_data.entries()) {
				chartValue[index] = value.ul;
				//let month = value.month;
				chartIndex[index] = value.month;
			}
		}
		let chart = 
		<Bar data={{
				// Name of the variables on x-axies for each bar
				labels: chartIndex,
				datasets: [
				{
					// Label for bars
					label: desc,
					// Data or value of your each variable
					data: chartValue,
					// Color of each bar
					backgroundColor: ["#0275d8", "#0275d8", "#0275d8", "#0275d8"],
					// borderWidth: "0.05",
					barThickness : "5",
				},
				],
			}}
			// Height of graph
			height={400}
			options={{
				maintainAspectRatio: false,
				scales: {},
				legend: {
				labels: {
					fontSize: 15,
				},
				},
			}}
		/>;
		setChartLable(chart);
	}
  	return (
<>
<Helmet link={
	[
		{"rel": "stylesheet", "href": 'css/Profile-stats.css'},
		{"rel": "stylesheet", "href": 'css/grph.css'}
	]
}/>
<div className="row no-gutters">
	<div className="bg-grey application">
		<div className="appHeader bg-transparent text-dark position-relative">
		<div className="left">
			<a className="headerButton goBack"   onClick={() => history.goBack()}>
				<img alt="" src={require("./../images/back-blue.png").default} className="img-fluid" />
			</a>
		</div>
		<div className="pageTitle">My Stats</div>
		</div>
		<div className="section my-4 text-center">
			<p>Monthly Trend</p>
			<div className="row">
			<div className="profile_chart">
				{chartLable}
			</div>
			</div>
			<div className="row justify-content-center grph-pt">
			<div className="col-md-10 col-lg-10 col-10">
				<div className="row">
				<div className="col-6 col-md-6 col-lg-6 mb-3">
					<button className={css.dau_percentage} onClick={() => loadChart('dau')}>
					<p className="btn-title">DAU</p>
					<p className="mb-0 number-text">
						<img alt="" src={css.dau_percentage_img} className="img-fluid" />
						<span className="btn-number-text ">{parseFloat(stats.dau_percentage).toFixed(2)}</span>%
					</p>
					</button>
				</div>
				<div className="col-6 col-md-6 col-lg-6 mb-3">
					<button className={css.ppr_percentage} onClick={() => loadChart('ppr')}>
					<p className="btn-title">Cross Selling</p>
					<p className="mb-0 number-text">
						<img alt="" src={css.ppr_percentage_img} className="img-fluid" />
						<span className="btn-number-text ">{parseFloat(stats.ppr_percentage).toFixed(2)}</span>%
					</p>
					</button>
				</div>
				<div className="col-6 col-md-6 col-lg-6 mb-3">
					<button className={css.tpr_percentage} onClick={() => loadChart('tpr')}>
					<p className="btn-title">Token Growth</p>
					<p className="mb-0 number-text">
						<img alt="" src={css.tpr_percentage_img} className="img-fluid" />
						<span className="btn-number-text ">{parseFloat(stats.tpr_percentage).toFixed(2)}</span>%
					</p>
					</button>
				</div>
				<div className="col-6 col-md-6 col-lg-6 mb-3">
					<button className={css.ul_percentage} onClick={() => loadChart('ul')}>
					<p className="btn-title">User’s Lost</p>
					<p className="mb-0 number-text">
						<img alt="" src={css.ul_percentage_img} className="img-fluid" />
						<span className="btn-number-text ">{parseFloat(stats.ul_percentage).toFixed(2)}</span>%
					</p>
					</button>
				</div>
				</div>
			</div>
			</div>
		</div>
	</div>
	<div className="bg"></div>
</div>
</>
  	);
}

export default Stats;
